export const GameContentFieldTypes = Object.freeze({
  LINE: 'line',
  MULTILINE: 'multiline'
})



// WEBPACK FOOTER //
// ./src/modules/gamification/enum/GameContentFieldTypesEnum.js